import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import Navbar from "../../../components/Layouts/Navbar";
import Footer from "../../../components/Layouts/Footer";
import { useGetRandomNewsQuery } from '../../../components/Store/Features/NewsletterAPI';
import AllListing from '../../../components/Conference/AllListing';
import axios from 'axios';

const AtsConference = () => {
    const [data, setData] = useState(null);
    const { data: posts, error, isLoading } = useGetRandomNewsQuery('/conference/filtered_list/ats');
    const [atsData, setAtsData] = useState([]);
    const router = useRouter();

    useEffect(() => {
        const fetchData = async () => {
            const allowedSlugs = ['/ats-conference/ats-2022', '/ats-conference/ats-2024'];
            const currentUrl = window.location.pathname;

            if (!allowedSlugs.includes(currentUrl)) {
                return router.push('/404');
            }
        };
        fetchData();

        if (!error) {
            setAtsData(posts);
        }
    }, [router, posts, error]);

    useEffect(() => {
        const currentPath = router.asPath;
        const lastQuery = currentPath.split('/').pop();
        const yearMatch = lastQuery.match(/\d{4}/);
        const fetchedYear = yearMatch?.[0] || '2020';
        const [fetchedEvent, beforeLastHyphen] = lastQuery.split("-");

        setData({
            event: fetchedEvent,
            year: fetchedYear,
        });
    }, [router.asPath]);


    const herobannerData = {
        "2022": {
            background: "/img/events/png/banner_1.png",
            title: "ATS 2022 Conference",
        },
        "2024": {
            background: "/img/events/conference/ats-conference/ats-banner.png",
            title: "ATS 2024 Conference: A Comprehensive Review and Analysis",
        }
    };

    const bannerData = herobannerData[data?.year] || herobannerData["2022"];
    

    return (
        <>
            <Navbar />
            <AllListing
                eventName={"Ats Conference " + data?.year}
                imageSrc={bannerData.background}
                title={bannerData?.title}
                data={atsData}
                year={data?.year}
                eventSlugPrefix="ats-conference"
                slugPrefix={`ats-${data?.year}`}
                reportUrl="/report-store.php?therapeutic_areas=Respiratory Diseases"
            />
            <Footer />
        </>
    );
};

AtsConference.getInitialProps = async (NextPageContext) => {
    const slugData = NextPageContext.query.conferences;

    try {
        const response = await axios.get(`${process.env.API_URL}/meta/${slugData}`);
        return {
            title: response?.data.meta_title || "Healthcare Market Research Reports & Consulting Firm | DelveInsight",
            description: response?.data.meta_description || "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies.",
            keywords: response?.data.meta_keywords || "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting, pharma consulting service, pharma leading, market trends.",
        };
    } catch (error) {
        console.error('Error fetching data:', error.message);
        return {
            title: "Healthcare Market Research Reports & Consulting Firm | DelveInsight",
            description: "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies.",
            keywords: "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting, pharma consulting service, pharma leading, market trends.",
        };
    }
}

export default AtsConference;
